import { LonelinessOptionsType } from './types';

export const LONELINESS_OPTIONS: LonelinessOptionsType = [
  {
    id: 'almost_every_day',
    title: 'Almost every day',
  },
  {
    id: 'quite_regularly',
    title: 'Quite regularly',
  },
  {
    id: 'sometimes',
    title: 'Sometimes',
  },
  {
    id: 'never',
    title: 'Never',
  },
];
